import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Button } from '@blueprintjs/core';
import { IFilterType } from '../../../../../../types/ProfileTypes';
import { AdvanceSectionContainerStyle } from '../../../styles';
import { StoreAppContext } from '../../../../../../../App';
import { RenderItems } from '../RenderFields/RenderItems';
import { RenderItemsAdvanceHideSection } from './components/RenderItemsAdvanceHideSection';
import { intl } from '../../../../../../utils/Intl';
import Collapse from '../../../../Basic/Collapse/Collapse';

export const AdvanceSection = (props: {
  disabled: boolean;
  filter: IFilterType;
  onChange: (value: any) => void;
  advance?: boolean;
}) => {
  const { filter, disabled, onChange, advance } = props;
  const { booleanLabels, type, value, typeSource, source, label } = filter;
  const [filters, setFilters] = useState<IFilterType[]>([]);
  const appContext = useContext(StoreAppContext);

  const isAdvanceSection = type === 'ADVANCE_SECTION';
  const isAdvanceHideSection = type === 'ADVANCE_HIDE_SECTION';

  useEffect(() => {
    if (isAdvanceSection) {
      setFilters(props.filter?.filters ?? []);
    }
  }, [props.filter]);

  useEffect(() => {
    if (
      isAdvanceHideSection &&
      typeSource === 'ARRAY_CONTEXT' &&
      source &&
      appContext.app.filterContext.hasOwnProperty(filter.source)
    ) {
      const sources = appContext.app.filterContext[filter.source];
      if (JSON.stringify(sources) !== JSON.stringify(filters)) {
        setFilters(sources);
      }
    }
  }, [appContext.app.filterContext]);

  const createLabelOfState = useCallback(() => {
    if (!value) {
      return booleanLabels ? booleanLabels['true'] : intl('app.show');
    }
    return booleanLabels ? booleanLabels['false'] : intl('app.hide');
  }, [value]);

  const createSubLabel = useCallback(() => {
    if (isAdvanceHideSection) {
      return `${filters.length} ${label}`;
    }
    return label;
  }, [label, type, filters]);

  const onChangeSection = () => {
    onChangeSectionFilter(!value);
  };

  const onChangeSectionFilter = (value: boolean) => {
    props?.onChange({
      ...filter,
      value
    });
  };

  const renderItemFromType = useMemo(() => {
    return (
      <>
        {isAdvanceSection ? (
          <RenderItems {...{ filters, onChange, beforeKey: 'advanceSection', getValueOnSelectMenuItem: true }} />
        ) : (
          <RenderItemsAdvanceHideSection {...{ filters, onChange, advance, beforeKey: 'advanceHideSection' }} />
        )}
      </>
    );
  }, [filters, onChange, advance]);

  return (
    <AdvanceSectionContainerStyle {...{ advance, isHideSection: isAdvanceHideSection }}>
      <Button
        disabled={disabled}
        className={'advance-section'}
        intent={'success'}
        icon={value ? 'remove' : 'plus'}
        minimal
        text={`${createLabelOfState()} ${createSubLabel()}`}
        onClick={onChangeSection}
      />
      <Collapse isOpen={value} transitionDuration={300} className={'collapse-advance-section'}>
        {renderItemFromType}
      </Collapse>
    </AdvanceSectionContainerStyle>
  );
};
